<wiz-hgroup width="100%" height="38px" class="widget-header" [verticalAlign]="'center'" padding="10px">
  <wiz-icon *ngIf="titleIcon">{{titleIcon}}</wiz-icon>
  <wiz-label [wizLabel]="title" [wizTextBehavior]="'truncate'" width="100%"></wiz-label>
</wiz-hgroup>
<wiz-label [wizLabel]="description" class="widget-content"></wiz-label>
